import React from 'react';

export interface FeatureCardProps {
    icon: string;
    title: string;
    description: string;
}

export const FeatureCard: React.FC<FeatureCardProps> = ({ icon, title, description }) => {
    return (
        <div className="bg-white p-8 text-center rounded-xl shadow-md  hover:shadow-xl transition-shadow duration-300">
            <div className="flex justify-center items-center mb-6 text-indigo-600">
                <img
                    src={icon}
                    alt="Blockchain Process Illustration"
                    className="max-w-full h-auto rounded-lg"
                />
            </div>
            <h3 className="text-2xl font-[500] text-[#1C2347] mb-2">{title}</h3>
            <p className="text-[#6B6B6B] font-[400] leading-relaxed">{description}</p>
        </div>
    );
};